/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlMuteRequestBody
 */
export interface ControlMuteRequestBody {
    /**
     * 
     * @type {string}
     * @memberof ControlMuteRequestBody
     */
    asset?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlMuteRequestBody
     */
    datapoint?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlMuteRequestBody
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof ControlMuteRequestBody
     */
    requested_by?: string;
}

/**
 * Check if a given object implements the ControlMuteRequestBody interface.
 */
export function instanceOfControlMuteRequestBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "reason" in value;

    return isInstance;
}

export function ControlMuteRequestBodyFromJSON(json: any): ControlMuteRequestBody {
    return ControlMuteRequestBodyFromJSONTyped(json, false);
}

export function ControlMuteRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlMuteRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'datapoint': !exists(json, 'datapoint') ? undefined : json['datapoint'],
        'reason': json['reason'],
        'requested_by': !exists(json, 'requested_by') ? undefined : json['requested_by'],
    };
}

export function ControlMuteRequestBodyToJSON(value?: ControlMuteRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'datapoint': value.datapoint,
        'reason': value.reason,
        'requested_by': value.requested_by,
    };
}

